import apiClient from '../client'

export interface ReleaseHistoryUpsert {
  version: string
  title: string
  body: string
  releasedAt: string
}

export const adminReleaseHistoriesApi = {
  create(data: ReleaseHistoryUpsert) {
    return apiClient.post('/api/admin/release-histories', data, {
      _suppressToastOnFieldErrors: true,
    })
  },
  update(id: number, data: ReleaseHistoryUpsert) {
    return apiClient.put(`/api/admin/release-histories/${id}`, data, {
      _suppressToastOnFieldErrors: true,
    })
  },
}
